module.exports = __webpack_public_path__ + "static/media/figma.16d37a2d.svg";